import { useTranslation } from '@packages/utils';
import Security from 'pages/private/Security';
import TeamList from 'pages/private/Team/TeamList';
import LightBox from 'pages/private/LightBox';
import DuplicateMerge from 'pages/private/Settings/DuplicateMerge';
import { RoutesPaths, SubRouteType } from 'routes/Routes.types';
import { useCheckPermission } from 'hooks/useCheckPermission';
import { EUserType } from 'data/types/user.types';
import { useAppSelector } from 'redux/store';

const useGetSettingsSidebarData = () => {
  const { t } = useTranslation({
    keyPrefix: 'descriptions.admin-portal.sidebar',
  });
  const user = useAppSelector(state => state.userSlice?.user);
  const isSuperAdmin = user?.type?.includes(EUserType.SUPER_ADMIN) ?? false;
  const canViewDuplicateMerge =
    useCheckPermission('DUPLICATE_MANAGEMENT_VIEW') || isSuperAdmin;
  const settingsSubRoutes: SubRouteType[] = [
    {
      title: t('SECURITY'),
      component: Security,
      path: RoutesPaths.SECURITY,
      show: false,
      showByPermissions: useCheckPermission('SECURITY_VIEW'),
    },
    {
      title: t('TEAM'),
      component: TeamList,
      path: RoutesPaths.TEAM,
      show: true,
      showByPermissions: useCheckPermission('ADMIN_LIST_VIEW'),
    },
    {
      title: t('LIGHT_BOX'),
      component: LightBox,
      path: RoutesPaths.LIGHT_BOX,
      show: true,
      showByPermissions: useCheckPermission('LIGHT_BOX_VIEW'),
    },
    {
      title: t('DUPLICATE_MERGE'),
      component: DuplicateMerge,
      path: RoutesPaths.SETTINGS_DUPLICATE_MERGE,
      show: true,
      showByPermissions: canViewDuplicateMerge,
    },
  ];
  return { settingsSubRoutes };
};

export default useGetSettingsSidebarData;
